<template>
  <div id="app">
    <nav-bar></nav-bar>
      <div class="content-wrapper">
        <main class="main-content">
          <router-view></router-view>
        </main>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar
  }
}
</script>

<style>
:root {
  --bg-color: #e8e1d5;
  --card-bg: #f5f0e8;
  --primary-color: #4361ee;
  --text-color: #2d3748;
  --text-secondary: #4a5568;
  --border-color: rgba(0, 0, 0, 0.06);
  --header-height: 64px;
  --shell-width: 1120px;
  --reading-width: 960px;
  --secondary-bg: #ffffff;
  --z-floating: 100;
  --z-reading-controls: 105;
  --z-overlay-backdrop: 109;
  --z-overlay: 110;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-padding-top: calc(var(--header-height) + 1rem);
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--bg-color);
  color: var(--text-color);
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
}

#app {
  background-color: var(--bg-color);
  min-height: 100vh;
}

.main-container {
  padding-top: var(--header-height);
  min-height: calc(100vh - var(--header-height));
}

.content-wrapper {
  margin: 0 auto;
  padding: calc(var(--header-height) + 2rem) 0 2rem;  /* 调整顶部内边距，包含导航栏高度 */
}

.main-content {
  width: 100%;
}

button,
input,
textarea,
select {
  font: inherit;
}

/* Typography */
h1 {
  font-size: 2.5rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  margin-bottom: 1.5rem;
  color: var(--text-color);
}

h2 {
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

/* Element UI overrides */
.el-pagination {
  margin-top: 2rem;
  text-align: center;
}

.el-button--primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.el-button--primary:hover {
  background-color: #3651d4;
  border-color: #3651d4;
}

/* 修改卡片样式 */
.el-card {
  background: var(--card-bg);
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 修改卡片悬浮效果 */
.el-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

@media (max-width: 768px) {
  :root {
    --header-height: 56px;
  }

  .content-wrapper {
    padding-top: calc(var(--header-height) + 1.5rem);
  }
}

@media (max-width: 360px) {
  #app .el-pagination.is-background .btn-prev,
  #app .el-pagination.is-background .btn-next,
  #app .el-pagination.is-background .el-pager li {
    min-width: 28px;
    margin: 0 2px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
